module.exports = __webpack_public_path__ + "fonts/MD5.222440d6.woff";